import httpManager from "@/app/shared/utils/httpManager";
/**
 * Crear un nuevo troncal.
 *
 * @param {Object} userData Datos del troncal a crear.
 *
 * @return {Promise<Object>} Nuevo troncal
 */
export default async function (trunkData) {
  const body = {
    ...trunkData,
  };
  const response = await httpManager.post("/pbx/trunks/", body);
  return response?.data;
}
